export default {
  person: {
    is: 'Einstaklingsþjónusta',
    en: 'Personal banking service',
  },

  corporate: {
    is: 'Fyrirtækjaþjónusta',
    en: 'Corporate banking service',
  },

  bookAppointment: {
    is: 'Panta tíma',
    en: 'Make an appointment',
  },
  subTitle: {
    is: 'Sérfræðingar okkar taka vel á móti þér í viðtalstíma. Veldu þá þjónustu sem hentar þér',
  },
};
